module.exports = new __parcel__URL__("arrow-right-mismatch.65202d42.svg").toString();